'use strict';

/**
 * @description helper script to retrieve reviews and comments and render them on a page
 * @note this script is identical to the core teasers.js script, but it is needed in this particular directory for proper webpack compilation
 */

 /**
 * @function
 * @name getAdjustedRating
 * @description the getAdjustedRating function adjusts/rounds the rating to have decimal value of .0 or .5
 * @param {string} rating -
 * @return {number} adjusted rating decimal value
 */
function getAdjustedRating(rating) {
    var floorValue = Math.floor(rating);
    var rounded = Math.round(rating * 100) / 100;
    var decimalValue = parseFloat((rounded - floorValue).toFixed(2));
    if (decimalValue < 0.25) {
        return floorValue;
    } else if (decimalValue < 0.75) {
        return floorValue + 0.5;
    }
    return floorValue + 1;
}

 /**
 * @function
 * @name createTeaserElement
 * @description This is a helper function used by other functions to create an element with a specific tag name and class name.
 *  Optionally pass “text” to populate the element with the provided text.
 * @param {string} tag type of DOM element
 * @param {string} className name of the element class
 * @param {string} text value to be added to the element
 * @return {Object} el DOM object
 */
function createTeaserElement(tag, className, text) {
    var el = document.createElement(tag);
    el.setAttribute('class', className);
    if (text) {
        el.innerHTML = text;
    }
    return el;
}

/**
 * @function
 * @name generateTeaserStar
 * @description The generateTeaserStars function creates an SVG element that references one of three possible stars (full, half or empty).
 *  The SVGs must be defined at the top of the body of the page.
 * @param {string} starType -
 * @return {Object} el DOM object
 */

function generateTeaserStar(starType) {
    var el = createTeaserElement('span', 'rating-icon icon-star-' + starType);
    return el;
}

 /**
 * @function
 * @name generateTeaserStars
 * @description The generateTeaserStars function is called by the populateTesear function to create the review stars.
 * @param {string} rating -
 * @return {Object} el DOM object
 */
function generateTeaserStars(rating) {
    var el = createTeaserElement('div', 'TTteaser__rating-panel');
    if (rating !== 0) {
        var adjustedRating = getAdjustedRating(rating);
        for (var i = 1; i <= 5; i++) {
            if (i > adjustedRating && i - adjustedRating >= 1) {
                el.appendChild(generateTeaserStar('0'));
            } else if (i <= adjustedRating) {
                el.appendChild(generateTeaserStar('100'));
            } else {
                el.appendChild(generateTeaserStar('50'));
            }
        }
    } else {
        for (var i = 1; i <= 5; i++) {
            el.appendChild(generateTeaserStar('0'));
        }
    }
    return el;
}

/**
 * @function
 * @name generateReadReviews
 * @description This function is called by the populateTeaser function to generate the link that will move to the place in the page
 *  where the reviews list is located by placing the name of the reviews list div id in the href.
 * @param {number} numReviews -
 * @return {Object} el DOM object
 */
function generateReadReviews(numReviews) {
	// Populate the 'Read x Reviews' text with the number of reviews and set
    // var text = 'Read ' + numReviews + ' Review' + (numReviews > 1 ? 's' : '');
    var text = '(' + numReviews + ')';
    var el = createTeaserElement('span', 'TTteaser__read-reviews-panel', 'Reviews ' + text);
    return el;
}

function generateReadReviewsPdpTop(numReviews) {
    var text = '(' + numReviews + ')';
    var el = createTeaserElement('span', 'TTteaser__read-reviews-panel-top', text);
    return el;
}
/**
 * @function
 * @name generateQuestions
 * @description This function is called by the populateTeaser function to generate the read questions
 * @param {number} numQuestions -
 * @param {number} numAnswers -
 * @return {Object} el DOM object
 */
function generateQuestions(numQuestions, numAnswers) {
	// Populate 'x Questions' text with the number of questions
    var text = numQuestions + ' Question' + (numQuestions > 1 ? 's' : '');

	// then populate the number of answers
    if (numAnswers > 0) {
        text = text + ', ' + numAnswers + ' Answer' + (numAnswers > 1 ? 's' : '');
    }

    var totalQACount = numQuestions + numAnswers;

    text = 'Questions & Answers (' + totalQACount + ')';

    var el = createTeaserElement('span', 'TTteaser__read-qa-panel', text);
    return el;
}

// eslint-disable-next-line
function generateNoQuestions() {
	// Populate 'x Questions' text with the number of questions
    var text = 'Ask a Question';

    var el = createTeaserElement('span', 'TTteaser__read-qa-panel TTteaser__read-no-qa', text);
    return el;
}

/**
 * @function
 * @name generateWriteReview
 * @description This function is called by the populateTeaser function to simply create a ‘Write a Review’ link.
 *  The click event handler for this element is added in the populateTesear function after the teaser has been rendered on the page.
 * @param {string} text value to be added to the element
 * @return {Object} DOM object
 */
function generateWriteReview(text) {
    return createTeaserElement('span', 'TTteaser__write-review-panel', text);
}

/**
 * @function
 * @name populateQATeasers
 * @description This function calls other functions to build specific parts QnA of your CGC Teaser.
 * @param {Object} counts response from ugc counts URL
 */
function populateQATeasers(counts) {
    var fragment = document.createDocumentFragment();
    if (counts.questions > 0) {
        // fragment.appendChild(document.createTextNode(' | '));
        fragment.appendChild(generateQuestions(counts.questions, counts.answers));
    } else {
        // fragment.appendChild(document.createTextNode(' | '));
        fragment.appendChild(generateNoQuestions());
    }

    var teaserElem = document.getElementById('tt-teaser-qa');
    if (!teaserElem) {
        return;
    }
    teaserElem.textContent = '';
    teaserElem.appendChild(fragment);
}

/**
 * @function
 * @name populateTeaser
 * @description This function calls other functions to build specific parts of your CGC Teaser.
 *  It should be modified to account for what content types you want to promote and/or the messaging you want based on the count returned.
 *  It ends with the writeReview function that spawns the TurnTo review form from your CGC Teaser.
 *  Note: If the reviews list and/or comments are initially hidden under a tab, see the Linking to your Content Underneath
 *  a Tab section for an example of how to handle this situation.
 * @param {Object} counts response from ugc counts URL
 */
function populateTeaser(counts) {
    var fragment = document.createDocumentFragment();
    var productReview = document.createDocumentFragment();
    if (counts.reviews > 0) { // has reviews
        var avgRatingsText = counts.avgRatingFormatted + `<span class="avgRatingOpacity"> / 5</span>`;
        fragment.appendChild(generateReadReviews(counts.reviews));
        fragment.appendChild(generateTeaserStars(counts.avgRating));
        fragment.appendChild(createTeaserElement('span', 'tt-reviews-avgRating', avgRatingsText));
        productReview.appendChild(generateTeaserStars(counts.avgRating));
        productReview.appendChild(generateReadReviewsPdpTop(counts.reviews));
    } else {
        fragment.appendChild(generateWriteReview('Write a Review'));
    }
    var teaserElem = document.getElementById('tt-teaser-reviews');
    var productReviewElem = document.getElementById('product-name-review');
    if (!teaserElem && !productReviewElem) {
        return;
    }
    teaserElem.textContent = '';
    teaserElem.appendChild(fragment);
    productReviewElem.textContent = '';
    productReviewElem.appendChild(productReview);
}

/**
 * @description show rating start and count in PDP Quick by bar
 * @name populateQBBTeaser
 * @param {Object} counts response from ugc counts URL
 */
function populateQBBTeaser(counts) {
    var fragment = document.createDocumentFragment();
    if (counts.reviews > 0) { // has reviews
        fragment.appendChild(generateTeaserStars(counts.avgRating));
        var el = createTeaserElement('span', 'qbbTTteaser__count');
        el.append('(' + counts.ratingCount + ')');
        fragment.appendChild(el);
        var qbbteaserElem = document.getElementById('qbb-tt-teaser');
        if (qbbteaserElem) {
            qbbteaserElem.textContent = '';
            qbbteaserElem.appendChild(fragment);
        }
    } else {
        fragment.appendChild(generateTeaserStars(0));
        var qbbteaserElem = document.getElementById('qbb-tt-teaser');
        if (qbbteaserElem) {
            qbbteaserElem.textContent = '';
            qbbteaserElem.appendChild(fragment);
        }
    }
}

/**
 * @function
 * @description The loadTeaserCounts function first loads the UGC counts maintained by TurnTo and then calls the populateTeaser function.
 * @name loadTeaserCounts
 * @param {string} sku the product ID
 */
function loadTeaserCounts(sku) {
    var xhr = new XMLHttpRequest();
    var turntoUrl = turnToSiteDataVars.turnToUrl;
    var siteKey = turnToSiteDataVars.siteKey;

    if (turntoUrl.length === 0 || siteKey.length === 0) {
        return;
    }

    // eslint-disable-next-line no-undef
    var ugcCountsUrl = 'https://cdn-ws.' + turntoUrl + '/v5/sitedata/' + siteKey + '/' + sku + '/d/ugc/counts/' + turnToConfig.locale;
    xhr.open('GET', ugcCountsUrl, true);
    xhr.addEventListener('load', function () {
        if (xhr.responseText) {
            populateQATeasers(JSON.parse(xhr.responseText))
            populateTeaser(JSON.parse(xhr.responseText));
            populateQBBTeaser(JSON.parse(xhr.responseText));
        }
    });
    xhr.send();
}

module.exports = {
    loadTeaserCounts: loadTeaserCounts,
    generateTeaserStars: generateTeaserStars
};